export var LanguageLevel;
(function (LanguageLevel) {
    LanguageLevel["Undefined"] = "Undefined";
    LanguageLevel["Basic"] = "Basic";
    LanguageLevel["Medium"] = "Medium";
    LanguageLevel["Fluent"] = "Fluent";
    LanguageLevel["NativeBilingual"] = "NativeBilingual";
})(LanguageLevel || (LanguageLevel = {}));
/** Get all levels below the given languageLevel.
 * Example: For Fluent, Will retrieve Fluent, Medium, Basic and Undefined
 */
export const getLanguageLevelsBelow = (e) => {
    const languages = new Array();
    for (const value in LanguageLevel) {
        languages.push(LanguageLevel[value]);
        if (e === value)
            return languages;
    }
    return languages;
};
/** Get all levels from bottom to top the given languageLevel.
 * Example: For Medium, Will retrieve Medium, Fluent, NativeBilingual
 */
export const getLanguageLevelsTop = (e) => {
    // get LanguageLevel as array
    const languages = new Array();
    for (const value in LanguageLevel) {
        languages.push(LanguageLevel[value]);
    }
    // reverse array
    const languagesReversed = languages.reverse();
    // get index of the given languageLevel
    const index = languagesReversed.indexOf(e);
    // return all languages from bottom to top
    return languagesReversed.slice(0, index + 1);
};
//# sourceMappingURL=manfredite-language.interface.js.map